<template>
    <div>
<!--        Whatsapp broadcast completed with name-->
<!--        <strong>{{ $_.get(activity, "payload.title") }} </strong>-->
<!--        to-->
<!--        <strong>{{ $_.get(activity, "payload.numbers") }} </strong> numbers-->
        <span v-html="$t('notification.whatsappBroadcastCompleted', {title: $_.get(activity, 'payload.title'), numbers: $_.get(activity, 'payload.numbers') })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "WhatsappBroadcastCompleted",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
